import { useEffect } from 'react';

import useActiveCall from '@/hooks/use-active-call';
import { useProvider } from '@/hooks/use-provider';
import { PROVIDERS } from '@/providers';

export const useOpenTicket = () => {
  const call = useActiveCall();
  const [provider] = useProvider();

  useEffect(() => {
    if (!call) return;

    if (provider.id === PROVIDERS.OMNIHIT) {
      const ticketId = call.request.getHeader('X-Entity-ID');
      if (ticketId) {
        provider.openTicket(ticketId);
      }
    }
  }, [call, provider]);
};
